import { Bloco } from "@/components/Carregando"
import type { ReactNode } from "react"

// A forma do repasse que vai chegar: faixa do empregador, os três totais e as linhas da tabela. Na
// troca de mês a faixa já é a de verdade.
export const EsqueletoRepasse = ({ cabecalho }: { cabecalho?: ReactNode }) => (
    <div className="overflow-hidden rounded-xl border border-line bg-card shadow-sm">
        {cabecalho ?? (
            <div className="animate-pulse border-b border-line px-6 py-5 motion-reduce:animate-none">
                <Bloco className="h-6 w-2/3 max-w-sm" />
                <Bloco className="mt-2 h-3 w-1/2 max-w-xs" />
            </div>
        )}
        <div
            aria-busy="true"
            aria-live="polite"
            aria-label="Carregando o seu repasse"
            className="animate-pulse motion-reduce:animate-none"
        >
            <div className="grid gap-px bg-line sm:grid-cols-3">
                {[0, 1, 2].map((total) => (
                    <div key={total} className="bg-card px-6 py-4">
                        <Bloco className="h-3 w-1/2" />
                        <Bloco className="mt-2 h-7 w-2/3" />
                        <Bloco className="mt-2 h-3 w-1/3" />
                    </div>
                ))}
            </div>
            <div className="space-y-3 border-t border-line px-6 py-6">
                <Bloco className="h-4 w-1/4" />
                <Bloco className="h-3 w-2/3" />
                {[0, 1, 2, 3, 4].map((linha) => (
                    <Bloco key={linha} className="h-9 w-full" />
                ))}
            </div>
        </div>
    </div>
)
